export default __webpack_public_path__ + "media/src/assets/images/clockIcon-f56f0794474656330d02aa9294b4d3b5.svg";